export default __webpack_public_path__ + "static/media/github.dea49d48.png";